import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-white rounded shadow-sm col-6 p-10 p-lg-15 mx-auto" }
const _hoisted_2 = {
  key: 0,
  class: "com-sm-12"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Validating. Please Wait!")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "com-lg-6"
}
const _hoisted_6 = { class: "card" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "card-header bg-transparent border-bottom text-uppercase" }, " We are here to help. ", -1)
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, " You have been requested by Swift Identity to review Employment Background check requests. Please use the login and Email already provided to complete the signup process to begin the background check. ", -1)
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Create Account"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-4" }, " A Warm Welcome from Swift Identity ")
], -1)
const _hoisted_15 = { class: "fv-row mb-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Email", -1)
const _hoisted_17 = { class: "fv-row mb-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Password", -1)
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_22 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.showLoading && !_ctx.showCreate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", _hoisted_9, "Dear " + _toDisplayString(_ctx.client.first_name), 1),
              _hoisted_10,
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreate = true)),
                class: "btn btn-primary btn-lg waves-effect waves-light"
              }, " Create Account ")
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h4", _hoisted_13, "Your Email is: " + _toDisplayString(_ctx.client.email), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      onSubmit: _ctx.createClientAccount,
      id: "kt_login_password_reset_form",
      "validation-schema": _ctx.forgotPassword
    }, {
      default: _withCtx(() => [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_Field, {
            class: "form-control form-control-solid",
            type: "text",
            name: "email",
            autocomplete: "off",
            modelValue: _ctx.client.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.client.email) = $event)),
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_Field, {
            class: "form-control form-control-solid",
            type: "password",
            name: "password",
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", _hoisted_22, _hoisted_25, 512),
          _createElementVNode("button", {
            class: "btn btn-lg btn-light-primary fw-bolder",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCreate = false))
          }, " Cancel ")
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"]), [
      [_vShow, _ctx.showCreate]
    ])
  ]))
}